import { axiosMicroservice } from 'src/api/axios';

export const getUserPaymentInfo = async ({
  userId,
  email,
  app = 'FaceYoga',
}: {
  userId: string;
  email: string;
  app?: string;
}): Promise<{
  user_email: string;
  user_id: string;
  app: string;
  currency: string;
  country_code: string | null;
}> => {
  const { data } = await axiosMicroservice.get(
    `payment_info?email=${encodeURIComponent(email.replace(/ /g, '+'))}&app=${app}&user_id=${userId}`,
  );
  return data;
};
